/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

const scopes = {
  dashboard: true,
};

export { scopes as default };
